import Vue from 'vue'

const getDefaultState = () => {
    return {
        complexityLevel: {
            id: 0,
            idKindWork: 2,
            description1: "",
            price1: 0,
            needsApproval1: 1,
            description2: "",
            price2: 0,
            needsApproval2: 1,
            description3: "",
            price3: 0,
            needsApproval3: 1,
            description4: "",
            price4: 0,
            needsApproval4: 1,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("common/complexityLevel/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listComplexityLevel = result.data.result;

                return listComplexityLevel;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list complexity level: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`common/complexityLevel/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get complexity level`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get complexity level: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, complexityLevelRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`common/complexityLevel/create-update`, complexityLevelRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (complexityLevelRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.complexityLevel, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.complexityLevel;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
